export default "__VITE_ASSET__CWpbcv7p__"